import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import jQuery from 'jquery'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['apple-pay-button', 'savvy', 'embeddable'];
// Make axios available globally in Vue components as this.$axios
Vue.prototype.$axios = axios;

// Set up jQuery globally if you need it
window.jQuery = jQuery;
window.$ = jQuery;

// Set up the axios interceptor for requests
axios.interceptors.request.use(
  (config) => {
    let token = store.getters.authToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Set up the axios interceptor for responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.commit('updateAccessToken', null);
      const currentPath = router.currentRoute.fullPath;
      const query = { page_ref: currentPath };
      // Try to get email from the failed request body (e.g. intake form)
      try {
        const reqData = JSON.parse(error.config.data);
        if (reqData?.email) query.email = reqData.email;
      } catch (e) {console.log(e)}
      // Fall back to store user email (expired session)
      if (!query.email) {
        const user = store.getters.user;
        if (user?.email) query.email = user.email;
      }
      localStorage.removeItem('_ymain_key_');
      router.push({ path: '/login', query });
    }
    return Promise.reject(error);
  }
);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
